const BASE_URL = import.meta.env.VITE_API_BASE_URL || 'https://openapi.nocodebackend.com';
const INSTANCE = import.meta.env.VITE_API_INSTANCE || '53730_goal_achievement_app';
const SECRET_KEY = import.meta.env.VITE_API_SECRET_KEY;

const getHeaders = () => {
  const headers = {
    'Content-Type': 'application/json',
  };
  if (SECRET_KEY && SECRET_KEY !== 'your_secret_key_here') {
    headers['Authorization'] = `Bearer ${SECRET_KEY}`;
  }
  return headers;
};

export const api = {
  createUser: async (data) => {
    const response = await fetch(`${BASE_URL}/create/users?Instance=${INSTANCE}`, {
      method: 'POST',
      headers: getHeaders(),
      body: JSON.stringify(data)
    });
    if (!response.ok) throw new Error('Failed to register user');
    return response.json();
  },

  createSession: async (data) => {
    const response = await fetch(`${BASE_URL}/create/sessions?Instance=${INSTANCE}`, {
      method: 'POST',
      headers: getHeaders(),
      body: JSON.stringify(data)
    });
    if (!response.ok) throw new Error('Failed to create session');
    return response.json();
  },

  createStageResponse: async (data) => {
    const response = await fetch(`${BASE_URL}/create/stage_responses?Instance=${INSTANCE}`, {
      method: 'POST',
      headers: getHeaders(),
      body: JSON.stringify(data)
    });
    if (!response.ok) throw new Error('Failed to save stage response');
    return response.json();
  },

  getSessions: async () => {
    const response = await fetch(`${BASE_URL}/read/sessions?Instance=${INSTANCE}&sort=created_at&order=desc&limit=50`, {
      method: 'GET',
      headers: getHeaders()
    });
    if (!response.ok) throw new Error('Failed to fetch sessions');
    return response.json();
  },

  getStageResponses: async () => {
    const response = await fetch(`${BASE_URL}/read/stage_responses?Instance=${INSTANCE}&sort=created_at&order=desc&limit=100`, {
      method: 'GET',
      headers: getHeaders()
    });
    if (!response.ok) throw new Error('Failed to fetch stage responses');
    return response.json();
  },

  deleteSession: async (id) => {
    const response = await fetch(`${BASE_URL}/delete/sessions/${id}?Instance=${INSTANCE}`, {
      method: 'DELETE',
      headers: getHeaders()
    });
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || `Failed to delete session ${id}`);
    }
    return response.json();
  },

  deleteStageResponse: async (id) => {
    const response = await fetch(`${BASE_URL}/delete/stage_responses/${id}?Instance=${INSTANCE}`, {
      method: 'DELETE',
      headers: getHeaders()
    });
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || `Failed to delete response ${id}`);
    }
    return response.json();
  }
};